<template>
    <dashboard-criticality-card
        title="SRC"
        :fields="fields"
        :provider="provider"
        :enabled-levels="enabledLevels"
        excel-file-name="SRC" />
</template>

<script>
import SRCApi from "@/api/src-o";
import DashboardCriticalityCard from "./DashboardCriticalityCard.vue";

export default {
    components: { DashboardCriticalityCard },
    props: {
        enabledLevels: { type: Array, default: null },
    },
    data() {
        return {
            fields: [
                { name: "Personel", key: "EmployeeFullName" },
                { name: "Sicil No", key: "RegistrationCode" },
                { name: "Başlangıç Tarihi", key: "GivenDateStr" },
                { name: "Bitiş Tarihi", key: "EndDateStr" },
                { name: "Kalan Gün", key: "RemainingDate" },
            ],
        };
    },
    methods: {
        provider() {
            return SRCApi.Employee.Dashboard();
        },
    },
};
</script>
